import { withStyles } from '@material-ui/core';
import WifiThermostatWidget from './WifiThermostatWidget';
import styles from './styles';

export default withStyles(styles)(WifiThermostatWidget);
